export var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["NA_ORDER_STATUS"] = 0] = "NA_ORDER_STATUS";
    OrderStatus[OrderStatus["FREE"] = 1] = "FREE";
    OrderStatus[OrderStatus["PENDING"] = 2] = "PENDING";
    OrderStatus[OrderStatus["PAID"] = 3] = "PAID";
    OrderStatus[OrderStatus["OFFLINE_PENDING"] = 4] = "OFFLINE_PENDING";
    OrderStatus[OrderStatus["INITIATED"] = 5] = "INITIATED";
    OrderStatus[OrderStatus["CANCELED"] = 6] = "CANCELED";
    OrderStatus[OrderStatus["DECLINED"] = 7] = "DECLINED";
    OrderStatus[OrderStatus["AUTHORIZED"] = 8] = "AUTHORIZED";
    OrderStatus[OrderStatus["VOIDED"] = 9] = "VOIDED";
    OrderStatus[OrderStatus["PARTIALLY_PAID"] = 10] = "PARTIALLY_PAID";
})(OrderStatus || (OrderStatus = {}));
//# sourceMappingURL=OrderStatus.js.map